export default __webpack_public_path__ + "images/5bf206b96ed494180eb46fa42e18af58-crowd-success.svg";